import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackAuthenticateClick, trackPlaceOfferClick } from './tracking';
import { modalOpen } from '../../actions/authentication';
import { UserRelated } from '../../components/UserRelated';
import { selectPageType } from '../../selectors/page';
import { IApplicationState, TThunkDispatch } from '../../types/redux';
import { UserContainer } from '../UserContainer';
import { UtilitiesContainer } from '../UtilitiesContainer';

export const UserRelatedContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const isAuthenticated = useSelector<IApplicationState, boolean>(state => state.user.isAuthenticated);
  const pageType = useSelector(selectPageType);
  const placeOfferLink = useSelector<IApplicationState, string | null>(state => state.servicesLinks.placeOffer);

  const handlePlaceOfferClick = React.useCallback(() => trackPlaceOfferClick(pageType), [pageType]);
  const handleAuthenticateClick = React.useCallback(() => {
    dispatch(modalOpen());
    trackAuthenticateClick(pageType);
  }, [dispatch, pageType]);

  return (
    <UserRelated
      userMenu={isAuthenticated ? <UserContainer /> : null}
      utilities={<UtilitiesContainer />}
      placeOfferLink={placeOfferLink}
      onPlaceOfferClick={handlePlaceOfferClick}
      onAuthenticateClick={handleAuthenticateClick}
    />
  );
};
